import { UserPreferences } from './types';

/**
 * One change to a user's preferences.
 *
 * Changes travel as patches rather than whole preference objects so that other
 * open tabs can apply them on top of what they hold. Sending the whole object
 * would let a tab that loaded earlier undo a grid layout another tab just saved.
 */
export type PreferencesPatch =
    | { kind: 'columnState'; pageKey: string; value: any[] }
    | { kind: 'columnWidths'; pageKey: string; value: Record<string, number> }
    | { kind: 'dashboard'; key: string; value: unknown }
    | { kind: 'merge'; value: Partial<UserPreferences> };

export const applyPreferencesPatch = (prefs: UserPreferences, patch: PreferencesPatch): UserPreferences => {
    switch (patch.kind) {
        case 'columnState':
            return { ...prefs, columnStates: { ...prefs.columnStates, [patch.pageKey]: patch.value } };
        case 'columnWidths':
            return { ...prefs, columnWidths: { ...prefs.columnWidths, [patch.pageKey]: patch.value } };
        case 'dashboard':
            return { ...prefs, dashboard: { ...prefs.dashboard, [patch.key]: patch.value } };
        case 'merge':
            return { ...prefs, ...patch.value };
        default:
            return prefs;
    }
};
